import React from "react";
import ObjectApprovalMatrixSection from "../components/Approvals/ObjectApprovalMatrixSection";

// Configuration, and cross-cutting: the matrix governs every object type in Foundation, so it sits
// on its own route rather than inside any one of the things it governs.
export default function ObjectApprovalMatrixPage() {
    return (
        <div style={{display: "flex", flexDirection: "column", flexGrow: 1, height: "100%"}}>
            <div style={{flex: 1, overflow: "auto"}}>
                <ObjectApprovalMatrixSection/>
            </div>
        </div>
    );
}
